import { render, staticRenderFns } from "./NewPassForm.vue?vue&type=template&id=a680a728&scoped=true"
import script from "./NewPassForm.vue?vue&type=script&lang=js"
export * from "./NewPassForm.vue?vue&type=script&lang=js"
import style0 from "./NewPassForm.vue?vue&type=style&index=0&id=a680a728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a680a728",
  null
  
)

export default component.exports